import React, { useMemo } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { BenefitsList } from './benefits-list';
import { getBenefitsListContent } from './content';

type BenefitsListProps = {
	canPay: boolean;
};

export function BenefitsListSection({ canPay }: BenefitsListProps) {
	const benefitsListContent = useMemo(() => getBenefitsListContent(canPay), [canPay]);

	return (
		<Box xcss={BenefitsListSectionStyles}>
			<Box xcss={BenefitsBodyStyles}>
				<BenefitsList benefits={benefitsListContent || []} />
			</Box>
		</Box>
	);
}

const BenefitsListSectionStyles = xcss({
	boxSizing: 'border-box',
	minHeight: '236px',
});

const BenefitsBodyStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.250',
});
